// removed by extract-text-webpack-plugin
module.exports = {"a-legend":"_1WTCSQV_r1AOLUwwGD2jYz","a-legend--small-mobile":"_1f9xzVsiEXDp6NdXB7BLGT"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/FormInput/LegendStyle.scss
// module id = 952
// module chunks = 0